export default __webpack_public_path__ + "static/media/playElipse.9060f875.svg";